import { BillingApi, Configuration, type ConfigurationParameters } from '@teemill/billing';
import type { App } from 'vue';

export let client: BillingApi;
export let errorHandler: (e: any) => void;

export const billing = {
  async install(
    app: App,
    options: {
      client: ConfigurationParameters;
      errorHandler: (e: any) => void;
      setup: () => void;
    },
  ) {
    client = new BillingApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    errorHandler = options.errorHandler || ((e) => console.error(e));

    options.setup();
  },
};
